import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'react-bootstrap-5';

interface ClearFilterIconProps {
  onClear: () => void;
}

export function ClearFilterIcon({ onClear }: ClearFilterIconProps) {
  const handleClick = (event) => {
    event.stopPropagation();
    onClear();
  };

  return (
    <Button
      className="btn-icon-sm"
      variant="ghost"
      onClick={handleClick}
      onMouseDown={event => event.stopPropagation()}
    >
      <FontAwesomeIcon className="m-0" icon={faTimes} name="remove-control" />
    </Button>
  );
}

export default ClearFilterIcon;
